module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0147.jpg?v=a55bee20";